import { render, staticRenderFns } from "./PriceBreakdown.vue?vue&type=template&id=ee4a278a&"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports